<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Good Return #{{data.code}}</h4>
                    <p class="text-subtitle-1">Good Return Information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(perm.good_return.post) && data.state_code == stateDraft">
                    <v-btn color="primary" block @click="handlePost" :loading="postLoading">
                        <v-icon left>mdi-gesture-tap-button</v-icon>
                        Post
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.good_return.update)">
                    <v-btn depressed block @click="handleEdit" >
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.good_return.delete)">
                    <v-btn depressed block color="error--text" @click="handleDelete" :loading="deleteLoading">
                        <v-icon left>mdi-delete</v-icon> 
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Code</th>
                                <td>{{data.code}}</td>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <td>{{data.date}}</td>
                            </tr>
                            <tr>
                                <th>Purchase Order</th>
                                <td>
                                    <span v-if="data && data.purchase_order" class="text-decoration-underline font-weight-bold" @click="showPurchaseOrder" style="cursor: pointer">
                                        {{data.purchase_order.code}}
                                    </span>
                            </td>
                            </tr>
                            <tr>
                                <th>Warehouse</th>
                                <td>
                                    <span v-if="data && data.warehouse">
                                        {{data.warehouse.display_name}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>
                                    <PStatus :state="data.state"/>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Unit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(l, i) in data.lines" :key="i">
                                <td>
                                    <span v-if="l.item">
                                        {{l.item.display_name}}
                                    </span>
                                </td>
                                <td>{{l.quantity}}</td>
                                <td>
                                    <span v-if="l.measure_unit">
                                        {{l.measure_unit.name}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Created By</th>
                                <td>
                                    <span v-if="data.created_by">
                                        {{data.created_by.name}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>Created At</th>
                                <td>{{data.created_at}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Updated By</th>
                                <td>
                                    <span v-if="data.updated_by">
                                        {{data.updated_by.name}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>Updated At</th>
                                <td>{{data.updated_at}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../../data/permissions'
import service from './../../../services/purchase/goodReturn';
import PAlert from './../../../components/common/PAlert';
import PStatus from './../../../components/common/PStatus.vue';
import authorize from '../../../utils/authorize';
export default {
    components: {
        PAlert,
        PStatus
    },
    data() {
        return {
            data: {},
            loading: false,
            deleteLoading: false,
            postLoading: false,
            id: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            stateDraft: 1,
            perm: permissions
        }
    },
    methods: {
        fetchGoodReturn() {
            this.loading = true;
            service.get(this.id).then(response => {
                this.data = response.data
            }).finally(() => {
                this.loading = false;
            })
        },
        handleEdit() {
            this.$router.push({
                name: "GoodReturnEdit",
                params: {
                    id: this.id
                }
            })
        },
        handleDelete() {
            this.alert = {...this.alert, content: "Are you sure you want to delete?", value: true, callback: this.deleteAsync }
        },
        deleteAsync() {
            this.deleteLoading = true;
            service.remove(this.id).then(() => {
                this.$router.replace({ name: "GoodReturnList" })
            }).finally(() => {
                this.deleteLoading = false;
            })
        },
        showPurchaseOrder() {
            this.$router.push({ name: "PurchaseOrderDisplay", params: { id: this.data.purchase_order.id } });
        },
        handlePost() {
            this.alert = {...this.alert, content: "Are you sure you want to post?", value: true, callback: this.post }
        },
        post() {
            this.postLoading = true;
            service.post(this.id).then(() => {
                setTimeout(() => {
                    this.fetchGoodReturn();
                }, 800)
            }).finally(() => {
                this.postLoading = false;
            })
        },
        hasPermission(code){
            return authorize(code)
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.fetchGoodReturn();
    }
}
</script>

<style>

</style>